/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Highlight_Team_ScimInputs */



/**
* | output |
* | --- |
* | "SCIM user provisioning" |
*
* @param {Plan_Gate_Highlight_Team_ScimInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_highlight_team_scim = /** @type {((inputs?: Plan_Gate_Highlight_Team_ScimInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Highlight_Team_ScimInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("SCIM-Benutzerbereitstellung")
	return /** @type {LocalizedString} */ ("SCIM user provisioning")
});